<script>
	export let id = null;
	export let label = null;
	export let value = null;
	export let maxLength = null;
	export let required = false;
	export let disabled = false;
	export let placeholder = null;
</script>

{#if label}
	<label for={id} class:isrequired={required}>{label}</label>
{/if}
<input {id} class="form-control" type="text" {required} {disabled} {placeholder} {maxLength} bind:value />
